import { render, staticRenderFns } from "./Guards.vue?vue&type=template&id=db05546a&scoped=true&"
import script from "./Guards.vue?vue&type=script&lang=js&"
export * from "./Guards.vue?vue&type=script&lang=js&"
import style0 from "./Guards.vue?vue&type=style&index=0&id=db05546a&lang=scss&scoped=true&"
import style1 from "./Guards.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db05546a",
  null
  
)

export default component.exports